export function formatNumberToCurrency(price: number): string {
  if (!price && price !== 0) return ''

  return Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(price)
}
